import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fluid grid"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "mb-0 pl-0" }
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = { class: "col-10" }
const _hoisted_6 = { class: "col-10" }
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = { class: "col-10 pre-wrap" }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Contacts = _resolveComponent("Contacts")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.receivedData.companyName) + " ", 1),
              (_ctx.isInternalUser)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'CompanyDetails', params: { companyId: _ctx.receivedData.companyId }}
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", {
                        class: "pi pi-external-link p-1",
                        style: {"font-size":"1rem"}
                      }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-2 label" }, " Phone ", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.receivedData.companyPhone), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-2 label" }, " Address ", -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.receivedData.streetAddress), 1),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-2 label" }, "Postal", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.receivedData.postalAddress), 1),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-2 label" }, "Suburb", -1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.receivedData.suburb), 1),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-2 label" }, "City/Town", -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.receivedData.city), 1),
          (_ctx.receivedData.postCode && _ctx.receivedData.postCode.length>1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-2 label" }, "Postcode", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.receivedData.postCode), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.receivedData.companyNotes && _ctx.receivedData.companyNotes.length > 1 && _ctx.$store.getters.isInternalUser)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-2 label" }, "Company Notes", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.receivedData.companyNotes.trim()), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "mt-5" }, "Contacts", -1)),
          _createVNode(_component_Contacts, {
            contacts: _ctx.receivedData.contacts,
            view: "indented-list"
          }, null, 8, ["contacts"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}